import { Divider as ChakraDivider, DividerProps as ChakraDividerProps } from '@chakra-ui/react';

export function Divider({
  ...rest
}: ChakraDividerProps) {
  return (
    <ChakraDivider borderColor="light.200" {...rest} />
  );
}
